(function () {
	var elem = document.querySelectorAll('.carousel');
	var arrowShape =
		'M21.8,49.36a1.51,1.51,0,0,1,.36-.54L38.82,32.16a1.67,1.67,0,1,1,2.36,2.35L27.36,48.33H76.67a1.67,1.67,0,0,1,0,3.34H27.36L41.18,65.49a1.67,1.67,0,0,1,0,2.36,1.69,1.69,0,0,1-2.36,0L22.16,51.18h0a1.62,1.62,0,0,1-.35-.54,1.64,1.64,0,0,1,0-1.28Z';
	elem.forEach((elem) => {
		new Flickity(elem, {
			cellSelector: '.carousel__item',
			cellAlign: 'center',
			contain: false,
			groupCells: '100%',
			dragThreshold: 10,
			selectedAttraction: 0.01,
			friction: 0.18,
			wrapAround: false,
			initialIndex: '.initial-index',
			pageDots: false,
			adaptiveHeight: false,
			arrowShape: arrowShape,
			on: {
				ready: checkSliderAlone,
				resize: checkSliderAlone,
			},
		});
	});

	function checkSliderAlone() {
		// checkWrap();

		console.log(this);
		this.wrapAround = checkWrap();

		if (this.slides.length) {
			this.slides.length < 2
				? this.element.classList.add('flickity-is-single')
				: this.element.classList.remove('flickity-is-single');
		}
	}

	function checkWrap(
		carouselSelector = '.carousel',
		cellSelector = '.carousel__item'
	) {
		// if sum(carousel-cell width) > carousel width then wrap else not
		const carousel = document.querySelector(carouselSelector);
		const cells = carousel.querySelectorAll(cellSelector);

		if (carousel && cells) {
			let cellsTotalWidth = 0;
			cells.forEach((cell) => {
				const style = window.getComputedStyle(cell);
				cellsTotalWidth +=
					parseFloat(style.width) +
					parseFloat(style.marginRight) +
					parseFloat(style.marginLeft);
			});
			const carouselWidth = parseFloat(window.getComputedStyle(carousel).width);
			return cellsTotalWidth > carouselWidth;
		}

		return false;
	}
})();

(function () {
	let touchingCarousel = false;
	let startXCoordinate;

	document.body.addEventListener('touchstart', (e) => {
		if (e.target.closest('.flickity-slider')) {
			touchingCarousel = true;
		} else {
			touchingCarousel = false;
			return;
		}
		startXCoordinate = e.touches[0].pageX;
	});

	document.body.addEventListener(
		'touchmove',
		(e) => {
			if (
				!touchingCarousel ||
				!e.cancelable ||
				Math.abs(e.touches[0].pageX - startXCoordinate) < 8
			)
				return;
			e.preventDefault();
			e.stopPropagation();
		},
		{ passive: false }
	);
})();
